import {useTranslation} from "react-i18next";
import {ArrowLeftCircle} from "react-feather";
import {useHistory} from "react-router-dom";
import { useState } from "react";
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export interface IConfirmProps {
    onOk: () => Promise<any[]>;
    modalHeader?: string;
    modalBody?: string;
  }


export const BackButton = ({backPath, confirmProps}: { backPath?: string, confirmProps?: IConfirmProps}) => {
    const {t} = useTranslation();
    const history = useHistory();
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    
    const showModal = () => {
        setConfirmVisible(true);
    };

    const handleOk = async () => {
        if (confirmProps?.onOk) {
            setConfirmLoading(true);
            await confirmProps.onOk();
        }
        
        goBack();
    };

    const handleCancel = () => {
        setConfirmVisible(false);
    };

    const handleBack = () => {
        if (confirmProps)
            showModal();
        else 
            goBack();
    }

    const goBack = () => {
        history.push(backPath ? backPath : '/dashboard');
    }

    return (
        <>
            <ArrowLeftCircle onClick={() => handleBack()}/>
            {
                confirmProps ? 
                    <Modal 
                        title={<><ExclamationCircleOutlined className="ant-btn-dangerous pr-05"/>{confirmProps?.modalHeader}</>}
                        okType={'danger'}
                        okText={t('general.ok')}
                        visible={confirmVisible}
                        centered
                        confirmLoading={confirmLoading}
                        cancelText={t('general.cancel')}
                        onOk={() => handleOk()}
                        onCancel={() => handleCancel()}
                    >
                        <p>{confirmProps?.modalBody}</p>
                    </Modal> 
                : ''
            }
          </>      
    );
};
